var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrafts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.89474 5.36851C2.78947 5.965 2 7.33342 2 8.56149V18.0001C2 20.2457 3.75439 22.0001 6 22.0001H18C20.2456 22.0001 22 20.2457 22 18.0001V8.56149C22 7.33342 21.2105 5.965 20.1053 5.36851L13.7719 1.8422C12.7544 1.28079 11.2456 1.28079 10.2281 1.8422L3.89474 5.36851ZM4.84211 7.1229L11.2105 3.59658C11.7018 3.31588 12.2982 3.31588 12.7895 3.59658L19.1579 7.1229C19.6842 7.4036 20 7.94746 20 8.56149V18.0001C20 19.2632 19.2632 20.0001 18 20.0001H6C4.73684 20.0001 4 19.2632 4 18.0001V8.56149C4 7.94746 4.31579 7.4036 4.84211 7.1229ZM22 18.0001V9.31588C22 8.36851 21.0351 7.82465 20.2281 8.29834L12.7895 12.4211C12.2982 12.7018 11.7018 12.7018 11.2105 12.4211L3.77193 8.29834C2.96491 7.82465 2 8.36851 2 9.31588V18.0001C2 20.2457 3.75439 22.0001 6 22.0001H18C20.2456 22.0001 22 20.2457 22 18.0001Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrafts);
export default __webpack_public_path__ + "static/media/drafts.df97ced7.svg";
export { ForwardRef as ReactComponent };